<template>
  <div id="app">
    <headPage></headPage>
    <router-view/>
     <footPage></footPage>
  </div>
</template>

<script>
import enduserAPI from '@/api/enduser';
import publicAPI from '@/api/public';
import headPage from '@/components/headPage';
import footPage from '@/components/footPage';
export default {
  name: 'App',
  components: {
    headPage,
    footPage,
  },
  data() {
    return {
      serviceObj: {},
      messageTimer: false,
      timerOut: null,
    };
  },
  methods: {
  },
}
</script>

<style>
#app {
  font-family: Helvetica,Pingfang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,"sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 20px;
}
*{
  margin: 0;
  padding: 0;
}
a{
  text-decoration: none
}

html, body {
    width: 100%;
    height: 100%;
}
/*滚动条样式*/
body::-webkit-scrollbar {/*滚动条整体样式*/
    width: 6px;     /*高宽分别对应横竖滚动条的尺寸*/
}
body::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #CCC;
}
body::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: #999;
}
.el-button{
  border-radius: 2px!important
}
li{
  list-style: none
}
input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue